import * as React from 'react';

import { ISeoLink } from '../../types/offersData';
import styles from './SeoLinks.css';
import { Link } from '@cian/ui-kit';

interface ISeoLinksProps {
  seoLinks: ISeoLink[];
}

const SPACE_SYMBOL = '\u0020';

export const SeoLinks: React.FC<ISeoLinksProps> = ({ seoLinks }) => {
  return (
    <div className={styles['container']}>
      <div className={styles['content']}>
        {seoLinks.map(({ title, url }, index) => (
          <React.Fragment key={index}>
            {!!index && `${SPACE_SYMBOL}|${SPACE_SYMBOL}`}
            <Link href={url} inline color="current_color">
              {title}
            </Link>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};
